export default "__VITE_ASSET__TvV1VaeA__"